import React from "react";
import { useSelector } from "react-redux";
import Overallfilter from "./overallDashboard/Overallfilter";
import Onboardingdetails from "./overallDashboard/Onboardingdetails";
import Attendancedetails from "./overallDashboard/Attendancedetails";

const Overalldashboard = () => {
  const state = useSelector((state) => state);

  const RoleBased = useSelector((state) => state.SideBarFiles.Role);
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            {RoleBased != undefined ? (
              <h2 class="user-name mb-0 WelcomeContent">{`Welcome ${capitalizeFirstLetter(
                RoleBased
              )}! `}</h2>
            ) : null}
          </div>
        </div>
        <Overallfilter />

        <div className="dashboard-container">
          <div className="left-section">
            <Onboardingdetails />
          </div>

          <div className="right-section">
            <Attendancedetails />
          </div>
        </div>
      </div>
    </>
  );
};

export default Overalldashboard;
